import React, { useState, useEffect } from 'react';
import { GoTrash } from "react-icons/go";
import { FaPlus, FaTimes } from "react-icons/fa";
import './CartItem.css';

// RTK Query hooks
import {
  useGetServicesQuery,
  useAddServiceMutation,
  useDeleteServiceMutation
} from '../../services/cartApi';

const CartItem = ({ product, deleteCard, getImageUrl, hasServicePermission, kaporaInfo }) => {
  const [showModal, setShowModal] = useState(false);
  const [services, setServices] = useState([{ title: '', description: '', price: '' }]);
  
  // RTK Query hooks
  const { data: savedServices = [], refetch } = useGetServicesQuery(product.cart_id, {
    skip: !hasServicePermission || !product.cart_id
  });
  const [addService] = useAddServiceMutation();
  const [deleteService] = useDeleteServiceMutation();

  const handleServiceChange = (index, field, value) => {
    const newServices = [...services];
    newServices[index][field] = value;
    setServices(newServices);
  };

  const addServiceInput = () => {
    setServices([...services, { title: '', description: '', price: '' }]);
  };

  const removeServiceInput = (index) => {
    if (services.length > 1) {
      const newServices = [...services];
      newServices.splice(index, 1);
      setServices(newServices);
    }
  };

  const saveServices = async () => {
    // Boş inputları filtrele
    const validServices = services.filter(service => service.title.trim() !== '' || service.description.trim() !== '');

    if (validServices.length > 0) {
      // API üzerinden her bir hizmeti kaydet
      for (const service of validServices) {
        try {
          await addService({
            cart_item_id: product.cart_id,
            title: service.title,
            description: service.description,
            price: service.price
          });
        } catch (error) {
          console.error("Hizmet eklenirken hata:", error);
        }
      }

      // Inputları sıfırla
      setServices([{ title: '', description: '', price: '' }]);
    }

    setShowModal(false);
  };

  const handleDeleteService = async (serviceId) => {
    try {
      await deleteService(serviceId);
    } catch (error) {
      console.error("Hizmet silinirken hata:", error);
    }
  };

  // Sadece sayı girişine izin veren fonksiyon
  const handlePriceChange = (index, value) => {
    // Sadece sayılar ve noktaya izin ver
    const numericValue = value.replace(/[^0-9]/g, '');
    handleServiceChange(index, 'price', numericValue);
  };

  // Kapora engelinin ref kodu ile kaldırılıp kaldırılmadığını kontrol eden fonksiyon
  const isKaporaBypassed = () => {
    if (!kaporaInfo || !kaporaInfo.success) {
      return false;
    }

    // Ref kodu ile kapora engeli kaldırılmış ürünler listesinde bu ürün var mı?
    if (kaporaInfo.allowed_products && kaporaInfo.allowed_products.length > 0) {
      return kaporaInfo.allowed_products.some(
        allowedProduct => allowedProduct.stok_kodu === product.stok_kodu
      );
    }

    return false;
  };

  return (
    <div className='card-item'>
      <div className='card-product-header'>
        <span>Satıcı: <a href={`/${product.magaza_sef}/all`}><span>{product.magaza_adi}</span></a></span>
        {hasServicePermission && product.cart_id && (
          <button className='d-none' onClick={() => setShowModal(true)}>Hizmet Ekle</button>
        )}
      </div>
      <div className='w-100 border-bottom my-2 mb-3 shadow'></div>
      <div className='card-product-content'>
        <div className='card-product-info'>
          <a href={`/urun/${product.sef}`}>
            <img src={getImageUrl(product.image.i1)} alt={product.baslik} className='product-imagee' />
          </a>
          <a className='my-auto' href={`/urun/${product.sef}`}>
            <p className='mb-0'>{product.baslik}</p>
            {product.size !== 0 && (
              <span style={{ fontSize: '13px', color: '#dc3545', fontWeight: 'bold' }}>
                {product.yuzuk_aciklama ? (
                  <span dangerouslySetInnerHTML={{ __html: product.yuzuk_aciklama }} />
                ) : product.ring_pricing ? (
                  product.ring_pricing.description
                ) : (
                  `${product.size} numara seçildi${product.yuzuk_fiyat > 0 ? ` - ${product.yuzuk_fiyat} TL ek ücret` : ''}`
                )}
              </span>
            )}
            {
              product.kapora == 1 && !isKaporaBypassed() && (
                <span style={{ fontSize: '13px', color: '#dc3545', fontWeight: 'bold' }}>
                  Bu ürünün kaporası verilmiştir satın alınamaz.
                </span>
              )
            }
            {
              product.kapora == 1 && isKaporaBypassed() && (
                <span style={{ fontSize: '13px', color: '#28a745', fontWeight: 'bold' }}>
                  ✅ Kapora engeli ref kodu ile kaldırıldı - Satın alınabilir.
                </span>
              )
            }
          </a>
        </div>

        {/* Mobil görünümde alt kısımda yer alacak */}
        <div className='card-bottom-actions d-flex align-items-center gap-2'>
          <div className='card-quantity'>
            <p>Adet: {product.quantity || 1}</p>
          </div>
          <div className='card-price text-center'>
            <p>{(product.toplam_fiyat !== undefined ? product.toplam_fiyat : product.fiyat || 0).toLocaleString('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} TL</p>
          </div>
          <div className='card-remove'>
            <button className="delete-button" onClick={() => deleteCard(product.cart_id)}>
              <GoTrash size={18} />
            </button>
          </div>
        </div>
      </div>

      {/* Ürün bilgilerinin altında hizmet kartlarını göster - sadece normal sepet ürünleri için */}
      {product.cart_id && (
        <div className="service-cards-container" style={{ marginTop: '15px' }}>
          {savedServices.map((service, index) => (
            <div key={index} className="service-card">
              <button
                className="service-card-remove"
                onClick={() => handleDeleteService(service.id)}
                title="Hizmeti Sil"
              >
                <span>
                  <GoTrash size={16} />
                </span>
              </button>
              <div className="service-card-content">
                <h4 className="service-card-title">{service.title}</h4>
                <p className="service-card-description">{service.description}</p>
                {service.price && (
                  <p className="service-card-price">{parseInt(service.price).toLocaleString('tr-TR')} TL</p>
                )}
              </div>

            </div>
          ))}
        </div>
      )}

      {showModal && (
        <div className="service-modal-overlay">
          <div className="service-modal">
            <div className="service-modal-header">
              <h3>Eklemek İstediğiniz Hizmetler</h3>
              <button className="close-service-button" onClick={() => setShowModal(false)}>
                <span>
                  <FaTimes size={16} />
                </span>
              </button>
            </div>
            <div className="service-modal-body">
              {services.map((service, index) => (
                <div key={index} className="service-inputs">
                  <div className="service-input-header">
                    <span>Hizmet #{index + 1}</span>
                    {services.length > 1 && (
                      <button
                        type="button"
                        className="service-input-remove"
                        onClick={() => removeServiceInput(index)}
                        title="Bu satırı sil"
                      >
                        <span>
                          <GoTrash size={16} />
                        </span>
                      </button>
                    )}
                  </div>
                  <input
                    type="text"
                    placeholder="Hizmet Başlığı"
                    value={service.title}
                    onChange={(e) => handleServiceChange(index, 'title', e.target.value)}
                  />
                  <input
                    type="text"
                    placeholder="Hizmet Açıklaması"
                    value={service.description}
                    onChange={(e) => handleServiceChange(index, 'description', e.target.value)}
                  />
                  <input
                    type="text"
                    placeholder="Fiyat (TL)"
                    value={service.price}
                    onChange={(e) => handlePriceChange(index, e.target.value)}
                  />
                </div>
              ))}
              <button className="add-service-button" onClick={addServiceInput}>
                <FaPlus size={14} /> Yeni Hizmet Ekle
              </button>
            </div>
            <div className="service-modal-footer">
              <button className="cancel-button" onClick={() => setShowModal(false)}>İptal</button>
              <button className="save-button" onClick={saveServices}>Kaydet</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CartItem; 